import { Link } from 'gatsby'
import styled from 'styled-components'
import media from 'styled-media-query'

export const ButtonDasaLink = styled(Link)`
  text-decoration: none;
  button {
    all: unset;
    background: ${props => props.bg || 'var(--pink)'};
    color: white;
    cursor: pointer;
    border-radius: 4px;
    padding: 8px 16px;
    gap: 8px;
    display: flex;
    align-items: center;
    min-height: 48px;
    max-width: 310px;
    font-weight: 700;
    font-size: 16px;
    color: #f5f5f5;
    font-family: 'Dasa Sans';
    line-height: 150%;

    svg {
      margin-left: auto;
    }

   ${media.lessThan('medium')`
      
      font-size: 14px;
     
    `}

  }
`
export const ButtonDasa = styled.button`
  all: unset;
  display: flex;
  align-items: center;
  background: ${props => props.bg || 'var(--pink)'};
  cursor: pointer;
  border-radius: 4px;
  padding: 8px 16px;
  gap: 8px;
  min-height: 48px;
  max-width: 310px;
  font-weight: 700;
  font-size: 16px;
  color: #f5f5f5;
  font-family: 'Dasa Sans';
  line-height: 150%;

  svg {
    margin-left: auto;
  }

   ${media.lessThan('medium')`
      font-size: 14px;
      
    `}

`
